
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';

@Component({
	name: "FormPago",
})

export default class FormPago extends Vue {
	@Prop() pago_selected!: any
	@Prop() swEditar!: boolean
	@Prop() swModal!: boolean;
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	private tab: any = null;
	public dialog = false;
	$refs!: {
		form: HTMLFormElement,
	};

	pago = {
		id: null,
		paciente_id: '',
		consulta_id: '',
		fecha_pago: this.fecha,
		monto: 0,
		metodo_pago: '',
	}
	txtSearch = "";
	nombre_paciente = "";
	detalle_consulta = "";
	selected_paciente = {};
	lista_pendientes = []
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');

	mounted() {
		this.cargarDatos();
		this.dialog = this.swModal
		this.selected_paciente = {};
		this.consultorioStore.pacientes = [];
	}

	close() {
		this.$emit('close')
	}

	registrarPago() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}

		Alert.confirm(`Se realizará el registro del pago`, 'Registrar Pago?').then(async result => {
			if (result.isConfirmed) {
				await this.consultorioService.storePago(this.pago)
				this.limpiar()
				this.$emit('close')
				this.$emit('listar')
			}
		})


	}

	cargarDatos() {
		if (this.swEditar) {
			this.pago.id = this.pago_selected.id;
			this.pago.paciente_id = this.pago_selected.paciente_id;
			this.pago.consulta_id = this.pago_selected.consulta_id;
			this.pago.fecha_pago = this.pago_selected.fecha_pago;
			this.pago.monto = this.pago_selected.monto;
			this.pago.metodo_pago = this.pago_selected.metodo_pago ? this.pago_selected.color : '';

		}

	}
	seleccionCliente() {
		console.log(this.selected_paciente)
		this.nombre_paciente = this.selected_paciente.info_paciente
		this.lista_pendientes = this.selected_paciente.consultas
		if (this.paciente !== null) {
			//
		} else
			this.limpiar()

	}
	seleccionarPendiente(pendiente: any) {
		this.detalle_consulta = pendiente.info;
		this.pago.consulta_id = pendiente.id;
		this.pago.paciente_id = pendiente.paciente_id;
	}
	getPacientesPago(value: string) {
		this.loading
		let data = {
			txtSearch: value
		}
		this.consultorioService.getPacientesPago(data).then(res => {
			console.log(res);
			//this.pacientes_all = res;
		})
	}
	limpiar() {
		this.pago = {
			id: null,
			paciente_id: '',
			consulta_id: '',
			fecha_pago: this.fecha,
			monto: 0,
			metodo_pago: '',
		}
		this.selected_paciente = {};

	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get pacientes(): any {
		return this.consultorioStore.pacientes;
	}

	@Watch('txtSearch')
	search(value: string) {
		console.log(value);
		if (value != null && value.length > 2) {
			this.$nextTick().then(() => {
				this.getPacientesPago(value);
			})

			this.pacientes_all = this.consultorioStore.pacientes;
			console.log(this.pacientes_all);
		}
	}
}

